module.exports = __webpack_public_path__ + "static/media/comparison2.180d183f.png";